import { SharingDebitProjectExpenseResponse } from '@/app/models/sharingDetails';
import formatterMonetaryValue from '@/app/utils/numberUtils';
import { styled, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const RowTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  paddingRight: theme.spacing(2),
  backgroundColor: '#FCE5CD',
}));

type RuleClassificationTableGridParams = {
  rows: SharingDebitProjectExpenseResponse[];
};

function SharingTableHeaderDetail({ rows }: RuleClassificationTableGridParams) {
  const { t } = useTranslation('sharingDetails');

  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableBody>
          {rows.length > 0 ? (
            <TableRow>
              <RowTableCell colSpan={12}>
                <Typography component="span" sx={{ fontSize: '12px' }}>
                  {rows.map((row, index) => (
                    <span key={row.debitProjectCode}>
                      <b>{row.expenseGroup}</b> - {formatterMonetaryValue(row.value)}
                      {index < rows.length - 1 && ' '}
                    </span>
                  ))}
                </Typography>
              </RowTableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }} colSpan={12}>
                <Typography variant="subtitle2">{t('no.data.found')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SharingTableHeaderDetail;
